export const listingStatuses = ['active', 'disabled', 'deleted'] as const
export const listingToggleStatuses = ['active', 'disabled'] as const

export type ListingStatus = (typeof listingStatuses)[number]
export type ListingToggleStatus = (typeof listingToggleStatuses)[number]
